import { gql } from '@apollo/client/core';

const PublicPortfolioPostsQuery = gql`
  query userPublicPosts($slug: String!, $first: Int, $cursor: String) {
    userPublicPosts(slug: $slug, first: $first, after: $cursor) {
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
      nodes {
        archivedAt
        category
        author {
          ... on Anonymous {
            username
          }

          ... on Public {
            slug
          }
        }
        currentUserRating {
          value
        }
        content {
          ... on DealStory {
            id
            text
            title
          }
          ... on Link {
            link
            text
            title
          }
          ... on LinkedinPost {
            text
            title
          }
          ... on Story {
            text
            title
          }
          ... on YoutubeLink {
            link
            text
            title
          }
        }
        commentsCount
        contentId
        contentType
        createdAt
        membersOnly
        id
        isAnonymous
        topics {
          id
          name
          emoji
          slug
        }
        files {
          name
          signedId
          url
        }
        official
        pinned
        pinnedAt
        publishedAt
        slug
        totalRating
        totalWeight
        updatedAt
        viewsCount
      }
    }
  }
`;

export default PublicPortfolioPostsQuery;
